export const FAVOURITE_ACTION_TYPES = {
  LOAD_FAVOURITE_SUCCESS: 'LOAD_FAVOURITE_SUCCESS',
  MAKE_FAV_ITEM_OPTIMISTIC: 'MAKE_FAV_ITEM_OPTIMISTIC',
  REMOVE_FAV_ITEM_OPTIMISTIC: 'REMOVE_FAV_ITEM_OPTIMISTIC'
};
